<template>
  <div>
    <BannerInternoDois
    :titulo="'Comparar'"
    :subtitulo="'Escolha os empreendimentos'"
    :lead="'Clique em cima do empreendimento para selecionar'"
    ></BannerInternoDois>
    <div class="comparar ui-container">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <carousel
            v-if="empreendimentos.length > 0"
            :per-page="1"
            :paginationPadding="5"
            :paginationSize="15"
            :paginationActiveColor="'#13182c'"
            :perPageCustom="[[480, 1], [768, 2], [1024, 3]]"
            :loop="false"
            :autoplay="false"
            :paginationEnabled="true"
            :navigationEnabled="false"
            >
              <slide v-for="(item,index) in empreendimentos" :key="index">
                <div class="empreendimento"
                :class="{
                  'active' : index === tab || index === tabDois,
                  'activeLoading' : empreendimentos[index].isLoading
                  }">
                  <div class="empreendimento__imagem ui-image--cover"
                  :style="'background-image: url('+item.image+')'"
                  @click="aciveTab(index)">
                    <div class="empreendimento__hover">
                      <div class="empreendimento__nome">
                        {{item.title}}
                      </div>
                    </div>
                  </div>
                </div>
              </slide>
            </carousel>
          </div>
          <div class="col-12" v-if="tab !== '' && tabDois !== ''">
            <div class="box">
              <div class="row">
                <div class="col-md-4 col-12">
                  <div class="box__title">
                    Comparar <br>Empreendimentos
                  </div>
                  <div class="box__itens">
                    <div class="item">
                      Previsão de entrega
                    </div>
                    <div class="item">
                      Tipo de Obra
                    </div>
                    <div class="item">
                      Localização
                    </div>
                     <div class="item">
                      Bairro
                    </div>
                    <div class="item">
                      Referência
                    </div>
                    <div class="item">
                      Distância do Centro
                    </div>
                    <div class="item">
                      Caracteristicas
                    </div>
                  </div>
                </div>
                <div v-if="ArrayOne.length > 1" class="col-md-4 col-12" v-for="(item,index) in ArrayOne" :key="index">
                  <div class="image w-100 ui-image--cover" :style="'background-image: url('+item.image+');'">
                    <div class="image__bg">
                      <div class="image__nome">
                        {{item.title}}
                      </div>
                    </div>
                  </div>
                  <div class="dados w-100">
                    <ul>
                      <li>
                        {{item.end_date ? item.end_date : '--'}}
                      </li>
                      <li v-if="item.category">
                        <span v-for="(cat, index) in item.category" :key="index">
                          {{cat.name}}<span v-if="index !== item.category.length - 1">,</span>
                        </span>
                      </li>
                      <li v-if="!item.category">
                        --
                      </li>
                      <li>
                        {{item.address ? item.address : '--'}}
                      </li>
                      <li>
                        {{item.neighborhood ? item.neighborhood : '--'}}
                      </li>
                      <li>
                        {{item.reference ? item.reference : '--'}}
                      </li>
                      <li>
                        {{item.center_distance ? item.center_distance + ' metros' : '--'}}
                      </li>
                      <li v-if="item.characteristics" v-for="(caracteristica, index) in item.characteristics" :key="index">
                        {{caracteristica.title}}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import BannerInternoDois from './BannerInternoDois.vue'
import { Carousel, Slide } from 'vue-carousel'
import format from 'date-fns/format'
export default {
  data () {
    return {
      tab: '',
      tabDois: '',
      ArrayOne: [],
      ArrayImoveis: []
    }
  },
  components: {
    BannerInternoDois,
    Carousel,
    Slide
  },
  computed: {
    ...mapGetters([
      'empreendimentos'
    ])
  },
  created () {
    this._loadEmpreedimentos()
  },
  methods: {
    _loadEmpreedimentos () {
      let params = {
        page: '',
        filter: '',
        category: '',
        notPaginate: 1,
        for_sale: 1,
        delivered: ''
      }
      this.$store.dispatch('loadEmpreendimentos', params)
    },
    aciveTab (index) {
      if (this.tab === '' || this.tabDois === '') {
        this.$set(this.empreendimentos[index], 'isLoading', true)
        this._callBussines(index)
      } else {
        if (index === this.tab) {
          this.tab = this.tabDois
          this.tabDois = ''
          this.ArrayOne.shift()
          return true
        }
        if (index === this.tabDois) {
          this.tabDois = ''
          this.ArrayOne.pop()
          return true
        }
      }
    },
    _callBussines (index) {
      this.$store.dispatch('showEmpreendimento', this.empreendimentos[index].slug)
        .then((response) => {
          if (response.data.end_date) {
            response.data.end_date = format(response.data.end_date, 'DD/MM/YYYY')
          }
          response.data.category = this.empreendimentos[index].category

          this.$set(this.empreendimentos[index], 'isLoading', false)
          if (this.tab === '' && (this.tabDois === '' || this.tabDois !== index)) {
            this.tab = index
            this.ArrayOne.push(response.data)
          } else if (this.tabDois === '' && this.tab !== index) {
            this.tabDois = index
            this.ArrayOne.push(response.data)
            return true
          }
        })
        .catch((error) => {
          console.error(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/_variables.scss";
.comparar {
  background: $bgIntern;
  .empreendimento {
    margin: 0 10px;
    &__imagem {
      border-radius: 10px;
      cursor: pointer;
      filter: grayscale(100%);
      height: 600px;
      overflow: hidden;
      padding: 20px;
      position: relative;
      transition: all 0.3s;
    }
    &__hover {
      position: absolute;
      background-image: url(../assets/img/bg_empreendiments.png);
      bottom: 0px;
      left: 0px;
      min-height: 269px;
      padding: 20px;
      width: 100%;
    }
    &__nome {
      bottom: 30px;
      color: white;
      font-size: 26px;
      font-weight: 900;
      margin-bottom: 5px;
      position: absolute;
      text-transform: uppercase;
      word-wrap: break-word;
    }
    @media (max-width: 1200px){
      &__imagem {
        height: 450px;
      }
      &__nome {
        font-size: 23px;
      }
    }
  }
  .active {
    position: relative;
    .empreendimento__imagem {
      filter: none;
    }
    &:after {
      background: url(../assets/img/comparar.png);
      content: '';
      height: 127px;
      left: calc(50% - 63px);
      position: absolute;
      top: calc(50% - 63px);
      width: 126px;
    }
  }
  .activeLoading {
    position: relative;
    .empreendimento__imagem {
      filter: none;
    }
    &:after {
      background: url(../assets/img/comparar.gif);
      background-repeat: no-repeat;
      background-size: contain;
      content: '';
      height: 130px;
      left: calc(50% - 63px);
      position: absolute;
      top: calc(50% - 63px);
      width: 130px;
    }
  }
}
.box {
  background: white;
  border-radius: 10px;
  margin-top: 100px;
  padding: 70px 50px;
  &__title {
    color: $primary;
    font-size: 30px;
    font-weight: 900;
    line-height: 30px;
    margin: 175px 0;
    text-transform: uppercase;
  }
  &__itens {
    background: $box;
    border-radius: 10px;
    padding: 30px 30px 10px 30px;
    .item {
      color: $silver;
      font-size: 18px;
      font-weight: bold;
      min-height: 40px;
      margin-bottom: 10px;
      @media (max-width: 1200px){
        min-height: 60px;
      }
      @media (max-width: 991px){
        min-height: inherit;
      }
    }
  }
  .image {
    border-radius: 10px;
    height: 400px;
    margin-bottom: 40px;
    overflow: hidden;
    position: relative;
    &__bg {
      background: url(../assets/img/bg-image-menor.png);
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      bottom: 0;
      height: 120px;
      left: 0;
      position: absolute;
      width: 100%;
    }
    &__nome {
      bottom: 20px;
      color: white;
      font-size: 20px;
      font-weight: 900;
      left: 20px;;
      position: absolute;
      text-transform: uppercase;
      width: 100%;
    }
  }
  .dados {
    padding-left: 5px;
    li {
      color: $silver;
      font-size: 16px;
      min-height: 40px;
      margin-bottom: 10px;
      @media (max-width: 1200px){
        min-height: 60px;
      }
      @media (max-width: 991px){
        min-height: inherit;
      }
    }
  }
  @media (max-width: 1200px){
    margin-top: 40px;
    padding: 30px;
    &__title {
      font-size: 22px;
    }
    .image {
      &__nome {
        font-size: 18px;
      }
    }
  }
  @media (max-width: 991px){
    margin-top: 30px;
    padding: 15px;
    .image {
      height: 200px;
      margin-bottom: 20px;
      &__nome {
        bottom: 10px;
        font-size: 16px;
        left: 10px;
      }
    }
    &__title {
      font-size: 18px;
      margin: 75px 0;
    }
    .box__itens {
      padding: 10px;
      .item {
        font-size: 15px;
        font-weight: 400;
      }
    }
    .dados {
      li {
        font-size: 16px;
      }
    }
  }
  @media (max-width: 767px){
    &__title {
      font-size: 18px;
      margin: 0px 0 20px 0;
    }
    &__itens {
      .item {
        margin-bottom: 5px;
      }
    }
    .image {
      margin-top: 15px;
    }
    .dados {
      li {
        margin-bottom: 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Comparar.vue